module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/59.505e5640.png";